import { FC, useCallback, useContext, useState } from "react";
import EnterPhoneNumber from "../components/login/EnterPhoneNumber";
import { InputWithValidation } from "../types/input";
import VerifyCode from "../components/login/VerifyCode";
import AuthenticationContext from "../context/Authentication/AuthenticationContext";
import { useNavigate } from "react-router-dom";

enum Steps {
  EnterPhoneNumber,
  VerifyCode,
}

const AdminLogin: FC = () => {
  const { login: loginUser } = useContext(AuthenticationContext);

  const nav = useNavigate();

  const [mobile, setMobile] = useState<InputWithValidation<string>>({
    checked: false,
    validate: true,
    value: "",
  });
  const [hashCode, setHashCode] = useState<string>("");
  const [adminpanelkey, setAdminpanelkey] = useState<string>("");
  const [step, setStep] = useState<Steps>(Steps.EnterPhoneNumber);

  const changeStep = (step: Steps) => {
    setStep(step);
  };

  return (
    <div className="h-100 d-flex justify-content-center align-items-center">
      {step === Steps.EnterPhoneNumber ? (
        <EnterPhoneNumber
          mobile={mobile}
          setMobile={setMobile}
          setHashCode={setHashCode}
          setAdminpanelkey={setAdminpanelkey}
          backward={() => {
            nav(-1);
          }}
          forward={() => changeStep(Steps.VerifyCode)}
        />
      ) : (
        <VerifyCode
          backward={() => {
            changeStep(Steps.EnterPhoneNumber);
          }}
          changeMobile={() => changeStep(Steps.EnterPhoneNumber)}
          forward={(user) => {
            loginUser(user);
          }}
          mobile={mobile.value}
          adminpanelkey={adminpanelkey}
          hashcode={hashCode}
        />
      )}
    </div>
  );
};

export default AdminLogin;
